import React from 'react';
import NewsApi from '../../components/Admin/NewsApi';

const NewsApiPage = () => {
  return (
    <div className="admin-page">
      <NewsApi />
    </div>
  );
};

export default NewsApiPage;
